import React, { useEffect, useState } from "react";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from "../../../config/firebase";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import "./UploadService.css";

function UploadService() {
  const [form, setForm] = useState({ title: "", category: "" });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCats = async () => {
      const snapshot = await getDocs(collection(db, "categories"));
      const list = snapshot.docs.map((d) => d.data());
      setCategories(list);
    };
    fetchCats();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const img = image ? await uploadToCloudinary(image) : "";
      const slug = form.title.toLowerCase().replace(/\s+/g, "-");
      await addDoc(collection(db, "services"), {
        title: form.title,
        slug,
        image: img,
        category: form.category,
        createdAt: new Date(),
      });
      alert("Service added!");
      setForm({ title: "", category: "" });
      setImage(null);
      setPreview(null);
    } catch (err) {
      console.error(err);
      alert("Error while adding service");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!image) {
      setPreview(null);
      return;
    }
    const url = URL.createObjectURL(image);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [image]);

  return (
    <div className="upload-service-container">
      <div className="upload-card">
        <h2>Add Service</h2>
        <form className="upload-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label className="form-label">Title</label>
            <input type="text" placeholder="Service Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required />
          </div>

          <div className="form-row">
            <label className="form-label">Category</label>
            <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} required>
              <option value="">Select Category</option>
              {categories.map((c) => (
                <option key={c.slug || c.name} value={c.name}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-row image-row">
            <div>
              <label className="form-label">Feature Image</label>
              <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />
            </div>
            <div className="image-preview">
              {preview ? <img src={preview} alt="preview" /> : <div className="placeholder">No image selected</div>}
            </div>
          </div>

          <div className="form-actions">
            <button className="btn primary" type="submit" disabled={loading}>{loading?"Uploading...":"Add Service"}</button>
            <button type="button" className="btn ghost" onClick={()=>{ setForm({ title:'', category:'' }); setImage(null); setPreview(null); }}>Reset</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UploadService;